import { render, staticRenderFns } from "./Rotator5.vue?vue&type=template&id=3dd16f3e&scoped=true"
import script from "./Rotator5.vue?vue&type=script&lang=js"
export * from "./Rotator5.vue?vue&type=script&lang=js"
import style0 from "./Rotator5.vue?vue&type=style&index=0&id=3dd16f3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dd16f3e",
  null
  
)

export default component.exports